import React, { useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Paper, Container, Icon } from "@mui/material";

interface FaqProps {
  data: any;
}

const Faq: React.FC<FaqProps> = ({ data }) => {
  const [expanded, setExpanded] = useState<Record<string, number | null>>({});

  // Handles Accordion toggle
  const handleChange = (category: any, index: number) => (event: any, isExpanded: boolean) => {
    setExpanded((prevState) => ({
      ...prevState,
      [category]: isExpanded ? index : false, // Allow only one open per category
    }));
  };

  return (
    <>
      {data.map((categoryData: any, catIndex: number) => (
        <>
          <h2>{categoryData.category}</h2>
          <Paper sx={{ p: 2, mb: 3 }} key={catIndex}>
            {categoryData.questions.map((item: any, index: number) => (
              <Accordion
                key={index}
                elevation={0}
                expanded={expanded[categoryData.category] === index || false}
                onChange={handleChange(categoryData.category, index)}
              >
                <AccordionSummary
                  expandIcon={
                    <Icon
                      sx={{
                        // display: "inline-block",
                        transform: expanded[categoryData.category] === index ? "rotate(45deg)" : "rotate(0deg)",
                        transition: "transform 0.3s ease-in-out",
                      }}>add</Icon>
                    }>
                  <label>{item.question}</label>
                </AccordionSummary>
                <AccordionDetails>
                  {/* <Typography>{item.answer}</Typography> */}
                  <Typography component="div" dangerouslySetInnerHTML={{ __html: item.answer }} />
                </AccordionDetails>
              </Accordion>
            ))}
          </Paper>
        </>
      ))}
    </>
  );
};

export default Faq;
